import Spacer from '@/common/components/spacer';
import StatusBanner from '@/common/components/status-banner';
import StripePayment, { StripePaymentProps } from '@/checkout/components/stripe-payment';
import { useLocation } from 'react-router';
import { useState } from 'react';
import * as gtag from '@/common/utils/gtags.client';
import { StripePaymentElementChangeEvent } from '@stripe/stripe-js';

export interface StripePaymentFormFragmentProps extends StripePaymentProps {
  paymentError?: string;
}

export default function StripePaymentFormFragment({
  showCancellationBlurb,
  paymentError,
}: StripePaymentFormFragmentProps) {
  const [sentEvent, setSentEvent] = useState(false);
  const { pathname } = useLocation();

  const handlePaymentChange = (event: StripePaymentElementChangeEvent) => {
    if (event.complete && !sentEvent) {
      const isACheckoutPage = pathname.includes('review') || pathname.includes('swap');
      if (isACheckoutPage) {
        gtag.event('complete_payment_method');
        setSentEvent(true);
      }
    }
  };

  return (
    <>
      <StripePayment
        showCancellationBlurb={showCancellationBlurb}
        onPaymentChange={handlePaymentChange}
        paymentError={paymentError}
      />

      {paymentError ? (
        <>
          <Spacer variant="height24" />
          <StatusBanner
            variant="error"
            message={{
              text: paymentError,
            }}
          />
        </>
      ) : null}

      <input type="hidden" name="stripe-enabled" value="true" />
    </>
  );
}
